import styled from "@emotion/styled";
import React from "react";

const Container = styled.div`
  /* background-color: rgba(0,0,0,0.15); */
  background-color: #eb4129;
  padding: 8px 10px;
  border-radius: 5px;
`;

const Content = styled.div`
  text-align: center;
`;

const TextContainer = styled.div`
  font-size: 11px;
`;

const ValueContainer = styled.div`
  font-size: 20px;
`;

interface INumberContainer {
  value: string;
  text: string;
}

export default function NumberContainer(props: INumberContainer) {
  const { text, value } = props;

  return (
    <Container>
      <Content>
        <ValueContainer>{value}</ValueContainer>
        <TextContainer>{text}</TextContainer>
      </Content>
    </Container>
  );
}
